import { getTripsRequest, getTripByIdRequest } from '../requests';

async function getTrips({ commit }, filterString) {
	let response = [];
	try {
		response = await getTripsRequest({ filterString });
	} catch (err) {
		console.log(`Set Trips failed: ${  err}`);
		throw err;
	}
	commit('setTrips', response);
	return response;
}

async function getTripById({}, id) {
	return getTripByIdRequest(id);
}

export default { getTrips, getTripById };
